import { createStore } from 'vuex';
import { auth } from './auth.module';
import { scheme } from './scheme.module';
import { schemeContact } from './scheme-contact.module';
import { schemeBusinessEmail } from './scheme-business-emails.module';
import { schemeNote } from './scheme-note.module';
import { schemeBusinessNote } from './scheme-business-note.module';
import { schemeTrade } from './scheme-trade.module';
import { trade } from './trade.module';
import { application } from './application.module';
import { registrationBilling } from './registration-billing.module';
import { licenceNumber } from './licence-number.module';
import { schemeBusiness } from './scheme-business.module';
import { businessSearch } from './business-search.module';
import { schemeUser } from './scheme-user.module';
import { pendingLicenceAction } from './pending-licence-action.module';
import { tradeCheck } from './scheme-trade-check.module';
import { siteSettings } from './site-settings.module';
import { backofficeUser } from './backoffice-user.module';
import { passwordReset } from './password-reset.module';
import { tradingStandardsAdmin } from './trading-standards-admin.module';
import { softwareProvider } from './software-provider.module';
import { auditQuestions } from './audit-questions.module';
import { schemeUsage } from './scheme-usage.module';
import { tradingStandardsFeedback } from './trading-standards-feedback.module';
import { schemePlatformStatistics } from './scheme-platform-statistics.module';
import { matrixTypes } from './matrix-types.module';
import { blockedEmails } from './blocked-emails.module';
import { funder } from './funder.module';
import { funderUser } from './funder-user.module';
import { propertyCheckerUser } from './property-checker-user.module';
import { businessReports } from './business-reports.module';
import { energySuppliers } from './energy-suppliers.module';
import { disputes } from './disputes.module';
import { disputeSearch } from './dispute-search.module';
import { disputeNote } from './dispute-note.module';
import { brandmisuse } from './brandmisuse-module';
import { brandmisuseSearch } from './brandmisuse-search.module';
import { brandmisuseIntel } from './brandmisuse-intel-module';
import { disputeEvidence } from './dispute-evidence.module';
import { disputeAssociation } from './dispute-association.module';
import { addressLookup } from './address-lookup.module';
import { guaranteeProvider } from './guarantee-provider.module';
import { userRoleGroups } from './user-role-groups.module';
import { schemeBusinessWatchlist } from './scheme-business-watchlist.module';
import { businessWatchlistSearch } from './business-watchlist-search.module';
import { disputesMerge } from './disputes-merge.module';
import { eeiclaApiKey } from './eeicla-api-key.module';
import { guaranteeClaim } from './guarantee-claim-search.module';
import { guaranteePolicyClaim } from './guarantee-policy-claim.module';
import { dataSubjectAccessRequest } from './dsar.module';
import { dataSubjectAccessRequestSearch } from './dsar-search.module';
import { personRegistrationSearch } from './person-registration-search.module';
import { dataSubjectAccessRequestNote } from './dsar-note.module';
import { dataSubjectAccessRequestEvidence } from './dsar-evidence.module';
import { dataSubjectAccessRequestAssociation } from './dsar-association.module';
import { complaintTriage } from './complaint-triage.module';
import { complaint } from './complaint.module';
import { businessRegistrationSearch } from './business-registration-search.module';
import { personRegistration } from './person-registration.module';
import { personDocument } from './person-document.module';
import { businessRegistrationPerson } from './business-registration-person.module';
import { businessRegistration } from './business-registration.module';
import { businessRegistrationPeriod } from './business-registration-period.module';
import { complaintSearch } from './complaint-search.module';
import { complaintTriageSearch } from './complaint-triage-search.module';

const store = createStore({
  modules: {
    application,
    auth,
    scheme,
    schemeContact,
    schemeNote,
    disputes,
    schemeTrade,
    trade,
    registrationBilling,
    licenceNumber,
    schemeBusiness,
    schemeBusinessNote,
    schemeUser,
    pendingLicenceAction,
    tradeCheck,
    schemeBusinessEmail,
    siteSettings,
    backofficeUser,
    passwordReset,
    businessSearch,
    tradingStandardsAdmin,
    softwareProvider,
    auditQuestions,
    schemeUsage,
    tradingStandardsFeedback,
    schemePlatformStatistics,
    matrixTypes,
    blockedEmails,
    funder,
    funderUser,
    propertyCheckerUser,
    businessReports,
    energySuppliers,
    disputeSearch,
    disputeNote,
    disputeEvidence,
    disputeAssociation,
    addressLookup,
    guaranteeProvider,
    userRoleGroups,
    schemeBusinessWatchlist,
    businessWatchlistSearch,
    brandmisuse,
    brandmisuseSearch,
    brandmisuseIntel,
    disputesMerge,
    eeiclaApiKey,
    guaranteeClaim,
    guaranteePolicyClaim,
    dataSubjectAccessRequest,
    dataSubjectAccessRequestSearch,
    personRegistrationSearch,
    dataSubjectAccessRequestNote,
    dataSubjectAccessRequestEvidence,
    dataSubjectAccessRequestAssociation,
    complaintTriage,
    complaint,
    businessRegistrationSearch,
    personRegistration,
    personDocument,
    businessRegistrationPerson,
    businessRegistration,
    businessRegistrationPeriod,
    complaintSearch,
    complaintTriageSearch,
  },
  state: {
    sidebarIsCollapsed: true,
    isBusy: false,
  },
  mutations: {
    setIsBusy(state, newState) {
      state.isBusy = newState;
    },
    setSidebarCollapsed(state, collapsed) {
      state.sidebarIsCollapsed = collapsed;
    },
  },
});

export default store;
